document.addEventListener("DOMContentLoaded", () => {
  const verifyBtn = document.getElementById("verifyUnlockBtn");
  const subscribeContainer = document.getElementById("subscribeContainer");

  if (!verifyBtn || !subscribeContainer) return;

  verifyBtn.addEventListener("click", async () => {
    const cid = window.TTC_CUSTOMER_ID;
    if (!cid) {
      showGateModal("Please log in first to continue.");
      return;
    }

    verifyBtn.disabled = true;
    verifyBtn.textContent = "Verifying...";

    try {
      const res = await fetch(`/apps/packripper/gatecheck?customerId=${encodeURIComponent(cid)}`, {
        credentials: "include"
      });
      const data = await res.json();

      if (!data.ok) {
        let msg = "Access temporarily blocked.";
        if (data.reason === "disposable_email")
          msg = "Please use a real email to play — disposable addresses are not allowed.";
        if (data.reason === "ip_rate_limited")
          msg = "Too many new accounts from this device or IP in the last 24 hours. Please try again later.";
        if (data.reason === "fingerprint_rate_limited")
          msg = "Too many new accounts from this browser or device recently. Please try again later.";

        showGateModal(msg, true);
        return;
      }

      // ✅ Passed gate — show the subscribe form
      subscribeContainer.style.display = "block";
      verifyBtn.remove();

    } catch (err) {
      console.error("Gatecheck failed:", err);
      showGateModal("Unable to verify access right now. Please try again later.");
    }
  });

  function showGateModal(msg, redirect = false) {
    const div = document.createElement("div");
    div.className = "ttc-modal is-active";
    div.innerHTML = `
      <div class="ttc-modal-content ttc-modal--dark" style="max-width:420px;text-align:center;">
        <h3 class="ttc-modal-title">Access Restricted</h3>
        <p style="margin:16px 0;">${msg}</p>
        <button class="btn btn--primary" id="gateCloseBtn">Return Home</button>
      </div>`;
    document.body.appendChild(div);

    // 🔒 lock scroll
    const oldOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    document.getElementById("gateCloseBtn")?.addEventListener("click", () => {
      div.remove();
      document.body.style.overflow = oldOverflow;
      if (redirect) window.location.href = "/";
    });
  }
});


// ==========================================================
// ✅ Inline thank-you notice under Subscribe button (neutral tone)
// ==========================================================
document.addEventListener("DOMContentLoaded", () => {
  const subscribeBtn = document.querySelector("#ripper-subscribe-form button[type='submit']");
  const subscribeForm = document.getElementById("ripper-subscribe-form");
  const feedback = document.getElementById("ripperFeedback") || (() => {
    const div = document.createElement("div");
    div.id = "ripperFeedback";
    div.style.marginTop = "10px";
    subscribeForm?.appendChild(div);
    return div;
  })();

  if (!subscribeBtn || !subscribeForm) return;

  subscribeBtn.addEventListener("click", (e) => {
    const agree = subscribeForm.querySelector("input[name='subscribe']");
    if (agree && !agree.checked) return;

    e.preventDefault();

    // Show inline neutral notice
    feedback.innerHTML = `
      <p style="margin-top:10px;color:#444;font-size:0.95rem;">
        ✅ Subscription verified — unlocking access...
      </p>
    `;

    // Wait briefly so message is visible, then submit to Shopify
    setTimeout(() => {
      subscribeForm.submit();
    }, 1200);
  });
});
